import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IGetAQuoteIdResponse } from '../../models/ship/getAQuote.model';

interface IInitialState {
  quote?: IGetAQuoteIdResponse;
}
const initialState: IInitialState = {
  quote: undefined,
};

const quoteSlice = createSlice({
  name: 'quote',
  initialState,
  reducers: {
    setQuoteData(state, action: PayloadAction<IInitialState>) {
      state.quote = action.payload.quote;
    },
  },
});

export const quoteActions = quoteSlice.actions;
export default quoteSlice.reducer;
